import { DashboardAPI } from "utils/api";
import {
    firestore,
    MODEL_COLL,
    INSIGHTS_DATA_DOC,
    INSIGHTS_FEATURES_COLL,
    INSIGHTS_RUNS_COLL,
    SINGLE_ZONE_COOLING_DOC,
    SINGLE_ZONE_COOLING_CASES_COLL,
    SINGLE_ZONE_COOLING_ZONES_COLL,
} from "_firebase";

const featureRef = (modelId) =>
    firestore.doc(
        `${MODEL_COLL}/${modelId}/modelData/${INSIGHTS_DATA_DOC}/${INSIGHTS_FEATURES_COLL}/${SINGLE_ZONE_COOLING_DOC}`
    );

export const runSingleZoneCoolingCalculation = async ({ modelId }) => {
    return DashboardAPI({
        method: "POST",
        url: "/runSingleZoneCoolingCalculation",
        data: {
            modelId,
        },
    });
};

export const fetchSingleZoneCoolingResults = async (modelId) => {
    if (!modelId) return null;

    const featureSnap = await featureRef(modelId).get();
    if (!featureSnap.exists) return null;

    const currentRunId = featureSnap.data()?.currentRunId;
    if (!currentRunId) return null;

    const runRef = featureRef(modelId).collection(INSIGHTS_RUNS_COLL).doc(currentRunId);
    const runSnap = await runRef.get();
    if (!runSnap.exists) return null;

    const casesSnap = await runRef.collection(SINGLE_ZONE_COOLING_CASES_COLL).get();
    const cases = {};

    for (const caseDoc of casesSnap.docs) {
        const zonesSnap = await caseDoc.ref.collection(SINGLE_ZONE_COOLING_ZONES_COLL).get();
        const zones = {};
        zonesSnap.forEach((zoneDoc) => {
            zones[zoneDoc.id] = zoneDoc.data();
        });
        cases[caseDoc.id] = {
            ...(caseDoc.data() || {}),
            zones,
        };
    }

    return {
        runId: currentRunId,
        ...(runSnap.data() || {}),
        cases,
    };
};
